import { useCallback } from 'react';
import {
  useCart,
  CartVersion,
  useUpdateCartMutation,
  CartUpdateAction,
  CartUpdatePropertyName
} from '../../hooks/useCart';

export const useReward = () => {
  const { cart } = useCart();
  const [updateCart, { data }] = useUpdateCartMutation();
  const countryCode = cart.attributes.countryCode;

  const applyReward = useCallback(
    (reward: boolean) =>
      updateCart(CartUpdateAction.Reward, {
        [CartUpdatePropertyName.Reward]: reward ? 1 : 0,
        [CartUpdatePropertyName.CountryCode]: countryCode
      }),
    [updateCart, countryCode]
  );

  return {
    rewards:
      cart.attributes.version === CartVersion.MiniBag
        ? undefined
        : cart.attributes.rewardSummary?.redeemableAmount?.price,
    data,
    applyReward
  };
};
